import { J1LeftarrowD } from '@e3dc-react/icons'
import Breadcrumbs, { Breadcrumb } from '@e3dc-react/shell/Elements/Header/Breadcrumbs'
import { Box, IconButton, Stack, SxProps } from '@mui/material'
import { Variant } from '@mui/material/styles/createTypography'
import React from 'react'
import { makeStyles } from 'tss-react/mui'
export const useBreadcrumbStyles = makeStyles()((theme, props) => ({
  /* eslint-disable-next-line tss-unused-classes/unused-classes */
  breadcrumbItem: {
    whiteSpace: 'nowrap',
  },
  /*  eslint-disable-next-line tss-unused-classes/unused-classes */
  lastBreadcrumbItem: {
    whiteSpace: 'nowrap',
    fontWeight: theme.typography.fontWeightBold,
    color: theme.palette.text.primary,
    cursor: 'default',
  },
  root: {
    justifyContent: 'flex-start',
    alignItems: 'center',
    maxWidth: '100%',
    paddingTop: '1px',
    overflow: 'hidden',
  },
}))

interface Props {
  iconButtonRef?: React.RefObject<HTMLDivElement>
  wrapperRef: React.RefObject<HTMLDivElement>
  dotRef: React.RefObject<HTMLDivElement>
  onGoBack: () => void
  breadcrumbs: Breadcrumb[]
  variant?: Variant
  lastItemVariant?: Variant
  breakLastBreadcrumb?: boolean
  iconStyle?: SxProps
  sx?: SxProps
}

/**
 * Shared layout for breadcrumb components with back button and measurement containers
 */
export const BreadcrumbsLayout: React.FC<Props> = ({
  iconButtonRef,
  wrapperRef,
  dotRef,
  onGoBack,
  breadcrumbs,
  variant = 'body2',
  lastItemVariant,
  breakLastBreadcrumb = false,
  iconStyle,
  sx,
}) => {
  const { classes } = useBreadcrumbStyles()

  return (
    <>
      {/* Invisible dom element to get actual size of a shortened Element */}
      <Box style={{ position: 'absolute', visibility: 'hidden', height: 0, overflow: 'hidden' }} ref={dotRef}>
        ...
      </Box>
      <Stack
        component={'div'}
        justifyContent={'flex-start'}
        alignItems={'center'}
        direction={'row'}
        mb={2}
        sx={{ position: 'relative', overflow: 'auto', ...sx }}
      >
        {/* Invisible measurement container to get parent width without possible overflow as overflow cannot be hidden, because hidden refs don't return a width */}
        <Box
          ref={wrapperRef}
          id="measurement-container"
          style={{
            position: 'absolute',
            inset: 0,
            visibility: 'hidden',
            pointerEvents: 'none',
            overflow: 'hidden',
            zIndex: -1,
            whiteSpace: 'nowrap',
          }}
        />
        {iconButtonRef && (
          <Box ref={iconButtonRef}>
            <IconButton onClick={onGoBack}>
              <J1LeftarrowD />
            </IconButton>
          </Box>
        )}
        <Breadcrumbs
          iconStyle={iconStyle}
          breadcrumbs={breadcrumbs}
          rootClassName={classes.root}
          variant={variant}
          lastItemVariant={lastItemVariant}
          breakLastBreadcrumb={breakLastBreadcrumb}
        />
      </Stack>
    </>
  )
}
